module.exports = __webpack_public_path__ + "static/media/foodprocessor.249203fb.png";